import { defineModule } from '../utils/helpers';

const getFormWrapperElement = (form: HTMLFormElement) => {
  const formIdElement = form.querySelector<HTMLInputElement>(
    'input[name="form_id"]',
  );
  if (!formIdElement) return null;

  const formId = formIdElement.value;
  return document.getElementById(`frm_form_${formId}_container`);
};

const initFormMaxPage = () => {
  const formElements = document.querySelectorAll<HTMLElement>('.frm_forms');

  formElements.forEach((formElement) => {
    const maxPageElement = formElement.querySelector<HTMLInputElement>(
      '.frm_rootline_group .frm_page_bar .frm_rootline_single:last-child input',
    );
    if (!maxPageElement) return;

    formElement.style.setProperty(
      '--progress-limit',
      `${maxPageElement.value}`,
    );
    formElement.style.setProperty(
      '--progress-limit-text',
      `'${maxPageElement.value}'`,
    );
  });
};

const onFormComplete = (
  event: Record<string, any>,
  form: HTMLFormElement,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  response: { errors: string[]; content: string; pass: boolean },
) => {
  const formWrapperElement = getFormWrapperElement(form);
  if (!formWrapperElement) return;

  const modalElement = formWrapperElement.closest<HTMLElement>('.modal');
  if (!modalElement) return;

  modalElement.classList.add('modal--form-completed');

  // Formidable replaces the form with its confirmation, taking the focused
  // submit button with it — focus would land on <body>, outside the trap, and
  // the confirmation would never be announced. Move it onto the message so a
  // screen reader reads the new state, falling back to the check disc when the
  // message is styled away.
  const successElement =
    modalElement.querySelector<HTMLElement>('.frm_message') ??
    modalElement.querySelector<HTMLElement>('.modal__success');
  if (!successElement) return;

  if (!successElement.hasAttribute('tabindex')) {
    successElement.setAttribute('tabindex', '-1');
  }
  successElement.focus({ preventScroll: true });
};

const onFormPageChange = (
  event: Record<string, any>,
  form: HTMLFormElement,
  response: { errors: string[]; content: string; pass: boolean; page: number },
) => {
  const formWrapperElement = getFormWrapperElement(form);
  if (!formWrapperElement) return;

  initFormMaxPage();
  formWrapperElement.style.setProperty('--progress-value', `${response.page}`);
  formWrapperElement.style.setProperty(
    '--progress-value-text',
    `'${response.page}'`,
  );
};

export default defineModule(
  () => {
    initFormMaxPage();

    if (!window.jQuery) return;
    window.jQuery(document).on('frmFormComplete', onFormComplete);
    window.jQuery(document).on('frmPageChanged', onFormPageChange);
  },
  () => {
    if (!window.jQuery) return;
    window.jQuery(document).off('frmFormComplete', onFormComplete);
    window.jQuery(document).off('frmPageChanged', onFormPageChange);
  },
);
